// 物料
export default [
  {
    path: '/material',
    redirect: '/materials/item',
  },

  // 物品
  {
    path: '/materials/item',
    name: 'materials-model',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/model/index.vue'),
    meta: { title: '物品管理' },
  },
  {
    path: '/materials/item/add',
    name: 'materials-model-add',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/model/add/Index.vue'),
    meta: { title: '物品管理' },
  },
  {
    path: '/materials/item/edit/:id',
    name: 'materials-model-edit',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/model/edit/Index.vue'),
    meta: { title: '物品管理' },
  },
  {
    path: '/materials/item/detail/:id',
    name: 'materials-model-detail',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/model/detail/Index.vue'),
    meta: { title: '物品管理' },
  },

  // 材料
  {
    path: '/materials/material',
    name: 'materials-material',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/material/Index.vue'),
    meta: { title: '材料管理' },
  },
  {
    path: '/materials/material/add',
    name: 'materials-material-add',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/material/add/Index.vue'),
    meta: { title: '材料管理' },
  },
  {
    path: '/materials/material/detail/:id',
    name: 'materials-material-detail',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/material/detail/Index.vue'),
    meta: { title: '材料管理' },
  },
  {
    path: '/materials/material/edit/:id',
    name: 'materials-material-edit',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/material/edit/Index.vue'),
    meta: { title: '材料管理' },
  },

  // 子材料
  {
    path: '/materials/material/:id/sub-add',
    name: 'materials-material-sub-add',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/material/sub-add/Index.vue'),
    meta: { title: '材料管理' },
  },
  {
    path: '/materials/material/:id/sub-edit/:subId',
    name: 'materials-material-sub-edit',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/material/sub-edit/Index.vue'),
    meta: { title: '材料管理' },
  },
  {
    path: '/materials/material/:id/sub-detail/:subId',
    name: 'materials-material-sub-detail',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/material/sub-detail/Index.vue'),
    meta: { title: '材料管理' },
  },

  // 型材产品
  {
    path: '/materials/section-product',
    name: 'materials-section-product',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/section-product/Index.vue'),
    meta: { title: '型材产品' },
  },
  // {
  //   path: '/materials/section-product/add',
  //   name: 'materials-section-product-add',
  //   component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/section-product/add/Index.vue'),
  //   meta: { title: '型材产品' },
  // },
  {
    path: '/materials/section-product/detail/:code',
    name: 'materials-section-product-detail',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/section-product/detail/Index.vue'),
    meta: { title: '型材产品' },
  },
  {
    path: '/materials/section-product/edit/:code',
    name: 'materials-section-product-edit',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/section-product/edit/Index.vue'),
    meta: { title: '型材产品' },
  },

  // 底材
  {
    path: '/materials/basic-material',
    name: 'materials-basemat',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/basemat/Index.vue'),
    meta: { title: '底材管理' },
  },
  // {
  //   path: '/materials/basic-material',
  //   name: 'materials-basematerial',
  //   component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/basematerial/Index.vue'),
  //   meta: { title: '底材管理' },
  // },
  // {
  //   path: '/materials/basic-material/add',
  //   name: 'materials-basematerial-add',
  //   component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/basematerial/Add.vue'),
  //   meta: { title: '底材管理' },
  // },
  // {
  //   path: '/materials/basic-material/edit/:id/:code',
  //   name: 'materials-basematerial-edit',
  //   component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/basematerial/Edit.vue'),
  //   meta: { title: '底材管理' },
  // },

  // 导航和检索
  {
    path: '/materials/nav',
    name: 'materials-nav',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/nav/Index.vue'),
    meta: { title: '物料导航' },
  },
  {
    path: '/materials/search',
    name: 'materials-retrieval',
    component: () => import(/* webpackChunkName: "materials" */ '@/views/materials/retrieval/Index.vue'),
    meta: { title: '物料检索' },
  },
];
